const scriptCache = {};
const styleCache = {};

export function getStringHash(string: string): number {
  let hash = 0;
  let i = -1;
  let char;
  if (string.length === 0) return hash;
  // Convert to 32bit integer
  while (++i < string.length) {
    char = string.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return hash;
}

export function loadScript(src: string): Promise<void> {
  return new Promise((resolve) => {
    const scriptId = `danmaku_lottery_${getStringHash(src)}`;
    if (scriptCache[scriptId]) {
      return resolve();
    }
    const scriptEl = document.createElement("script");
    scriptEl.id = scriptId;
    scriptEl.src = src;
    scriptEl.type = "text/javascript";
    scriptCache[scriptId] = scriptEl;
    scriptEl.onload = () => resolve();
    // @ts-ignore
    scriptEl.onreadystatechange = function() {
      // @ts-ignore
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        resolve();
      }
    };
    document.querySelector("head")?.appendChild(scriptEl);
  });
}

export function insertCss(css: string): Promise<void> {
  return new Promise((resolve) => {
    const styleId = `danmaku_lottery_${getStringHash(css)}`;
    if (styleCache[styleId]) {
      return resolve();
    }
    const style = document.createElement("style");
    style.type = "text/css";
    // @ts-ignore
    if (style.styleSheet) {
      const ieInsertCSS = () => {
        // @ts-ignore
        style.styleSheet.cssText = css;
        setTimeout(() => resolve());
      };
      // @ts-ignore
      if (style.styleSheet.disable) {
        setTimeout(() => ieInsertCSS(), 200);
      } else {
        ieInsertCSS();
      }
    } else {
      style.appendChild(document.createTextNode(css));
      document.querySelector("head")?.appendChild(style);
      setTimeout(() => resolve());
    }
  });
}